export default __webpack_public_path__ + "bl-logo.c868e259.svg";